var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('large-button',{staticClass:"w3-button w3-border w3-round-xxlarge",on:{"click":function($event){_vm.$emit('click',$event)}}},[_c('i',{staticClass:"fa fa-floppy-o",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_vm._t("default",[_vm._v("Save")])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-535bd360","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/controls/buttons/SaveButton.vue
// module id = 874
// module chunks = 1